module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAY1BMVEUAAABDf9ZKiNNJiNMzfMxJh9NJiNNJh9NIh9NHhNNJiNNJh9NJiNNKh9NJh9VMidJJiNNJiNNKiNNJiNNKiNNJiNRKh9JIiNRJiNNKiNRIh9NJidFHhdFKiNNJiNJKiNRKiNP0I5oqAAAAIHRSTlMAC/vWB/HdpCkk5eHFeS0QzKrt0rmJclhNRj84MvSPjnQ+pwQAAAChSURBVBjTTY5XDsMwDEMlryzb2Tttef9TtrGdNO9HxINAkAJqal66mRTdFBIBWVymrtAvzEuPqk7qDcvn5QafpDocMRzoUhMqSlSIbTnkpSTycFmI1FoLwTENGGMYMVBkF3CKSDmIPancAGXbloDJo9k0jAzjLfQWfjQyJj/PnriFPldYZHSTwRKtKPmvuMT6844eOGRk4J/Kw5CAeioF8QUTegoX6YiIFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/old.png
// module id = 78tF
// module chunks = 1